import { takeEvery } from 'redux-saga/effects'
import { UI_SCROLL_BODY_TO } from '../actionTypes'

export default function* scrollBodyToSaga() {
  yield takeEvery(UI_SCROLL_BODY_TO, handleScrollBodyTo)
}

export function handleScrollBodyTo({ payload: { to } }) {
  document.body.scrollTop = to
}
